import { render, staticRenderFns } from "./V2NotificationPreferencesModal.vue?vue&type=template&id=1cf82b90&scoped=true&"
import script from "./V2NotificationPreferencesModal.vue?vue&type=script&lang=js&"
export * from "./V2NotificationPreferencesModal.vue?vue&type=script&lang=js&"
import style0 from "./V2NotificationPreferencesModal.vue?vue&type=style&index=0&id=1cf82b90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf82b90",
  null
  
)

export default component.exports